import React, { Fragment } from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

type Props = {
  classes: Object,
  post: Object,
  title: string,
};

const BlogListHeader = ({ classes, title }: Props) => {
  return (
    <Fragment>
      <div className={classes.root}>
        <Typography type="heading3" className={classes.blogTitle}>
          {title}
        </Typography>
        <form action="/blog" method="get" className={classes.blogSearch}>
          <input
            className={classes.blogSearchInput}
            type="search"
            id="site-search"
            name="title"
            placeholder="Search this blog"
            aria-label="Search through site content"
          />
        </form>
      </div>
    </Fragment>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    margin: "48px auto 32px",
    justifyContent: "center",
    flexDirection: "column",
  },
  blogTitle: {
    paddingRight: "0px",
    marginBottom: theme.spacing.unit,
    textAlign: "center",
  },
  blogSearch: {
    position: "relative",
    height: "46px",
    "&:hover": {
      color: theme.colors.gray["400"],
    },
    "&:before": {
      content: "''",
      position: "absolute",
      right: "16px",
      top: "4px",
      bottom: "0",
      width: "20px",
      paddingRight: theme.spacing.unit,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M15.5%2014h-.79l-.28-.27C15.41%2012.59%2016%2011.11%2016%209.5%2016%205.91%2013.09%203%209.5%203S3%205.91%203%209.5%205.91%2016%209.5%2016c1.61%200%203.09-.59%204.23-1.57l.27.28v.79l5%204.99L20.49%2019l-4.99-5zm-6%200C7.01%2014%205%2011.99%205%209.5S7.01%205%209.5%205%2014%207.01%2014%209.5%2011.99%2014%209.5%2014z%22%2F%3E%3C%2Fsvg%3E')`,
    },
  },

  blogSearchInput: {
    border: "none",
    backgroundColor: theme.colors.gray["100"],
    color: theme.colors.gray["900"],
    padding: "10px 34px 10px 16px",
    borderRadius: theme.globalBorderRadius,
    outline: "none",
    fontWeight: "600",
    fontSize: "14px",
    width: "280px",
    height: "48px",

    "&::placeholder": {
      color: theme.colors.gray["900"],
    },

    [theme.breakpoints(350)]: {
      width: "320px",
    },

    [theme.breakpoints(475)]: {
      width: "440px",
    },
  },
}))(BlogListHeader);
